import React, { useEffect } from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/Theme';
import RGForm from './page';
import RGShortForm from './page/RGShortForm';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import Background from './components/Background';
import { isCleanEmbedMode } from './config/embedMode';
import { CustomStepperWrapper } from './components/CustomWrapper';

function App() {
  useEffect(() => {
    if (isCleanEmbedMode) {
      document.body.classList.add('embed-mode');
    }

    const sendEmbedResize = () => {
      try {
        const pageHeight = Math.max(
          document.body?.scrollHeight || 0,
          document.documentElement?.scrollHeight || 0
        );

        // Supports host scripts that listen for postMessage-based iframe resizing.
        window.parent?.postMessage?.({ type: 'RG_FORM_EMBED_RESIZE', height: pageHeight }, '*');
      } catch (error) {
        // no-op to avoid noisy runtime errors in non-iframe contexts
      }
    };

    sendEmbedResize();

    if (!window.ResizeObserver) {
      window.addEventListener('resize', sendEmbedResize);
      return () => {
        document.body.classList.remove('embed-mode');
        window.removeEventListener('resize', sendEmbedResize);
      };
    }

    const observer = new ResizeObserver(() => {
      sendEmbedResize();
    });

    observer.observe(document.body);

    return () => {
      document.body.classList.remove('embed-mode');
      observer.disconnect();
    };
  }, []);

  return (
    <div className={`App${isCleanEmbedMode ? ' App--embed' : ''}`}>
      {!isCleanEmbedMode && <Background />}

      <ThemeProvider theme={theme}>
        <Router>
          <Route path="/:accountId" exact component={RGShortForm} />
          <Route path="/" exact component={RGForm} />
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
